var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 18C14.3877 18 14.5997 17.9122 14.756 17.7559C14.9122 17.5996 15 17.3876 15 17.1666V12.7083C15 12.3275 15.2634 12.005 15.6059 11.8408C16.315 11.5025 16.8819 10.9246 17.2064 10.209C17.5309 9.49348 17.5922 8.6863 17.3796 7.92993C17.1669 7.17356 16.6938 6.51663 16.0439 6.07508C15.394 5.63353 14.6091 5.43575 13.8275 5.51663C13.5057 4.76847 12.9716 4.13104 12.2913 3.68316C11.6111 3.23528 10.8145 2.99658 10 2.99658C9.18558 2.99658 8.38898 3.23528 7.70873 3.68316C7.02848 4.13104 6.4944 4.76847 6.17254 5.51663C5.39136 5.43631 4.6069 5.63438 3.95748 6.07591C3.30806 6.51744 2.83538 7.17408 2.62278 7.93005C2.41017 8.68602 2.4713 9.49278 2.79538 10.2081C3.11945 10.9234 3.68567 11.5013 4.3942 11.84C4.7367 12.005 5.00004 12.3275 5.00004 12.7075V17.1666C5.00004 17.3876 5.08784 17.5996 5.24412 17.7559C5.4004 17.9122 5.61236 18 5.83337 18H14.1667Z",
    fill: "#B1B1B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 14.6667H15",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.7cada9bde0f7636ac4318c83d789c3da.svg";
export { ForwardRef as ReactComponent };